import { Token } from '@warema/shared/authentication/models';
import { User } from '@warema/shared/models';
import { createImmerReducer, immerOn } from 'ngrx-immer/store';
import * as AuthenticationActions from './authentication.actions';

export interface AuthenticationState {
    initializing: boolean;
    token: Token | null;
    user: User | null;
    userError: string | null;
    userLoading: boolean;
}

export const authenticationFeatureKey = 'authentication';

export const authenticationReducer = createImmerReducer<AuthenticationState>(
    {
        initializing: true,
        token: null,
        user: null,
        userLoading: false,
        userError: null,
    },
    // ------------------------------------------------------------------------------------------
    // G E N E R A L
    // ------------------------------------------------------------------------------------------
    immerOn(AuthenticationActions.setTokenAction, (state, { token }) => {
        state.token = token;
    }),
    immerOn(AuthenticationActions.setUserUnauthenticatedAction, state => {
        state.token = null;
        state.user = null;
    }),
    immerOn(AuthenticationActions.setFinishedInitializingAction, state => {
        state.initializing = false;
    }),
    // ------------------------------------------------------------------------------------------
    // U S E R   I N F O   L O A D I N G
    // ------------------------------------------------------------------------------------------
    immerOn(AuthenticationActions.loadUserAction, state => {
        state.userLoading = true;
        state.user = null;
        state.userError = null;
    }),
    immerOn(AuthenticationActions.loadUserSuccessAction, (state, { user }) => {
        state.userLoading = false;
        state.user = user;
        state.userError = null;
    }),
    immerOn(AuthenticationActions.loadUserErrorAction, (state, { error }) => {
        state.userLoading = false;
        state.user = null;
        state.userError = error;
    }),
);
